import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import NotFound from './not-found/not-found';

export default function Root({ baseUrl }: { baseUrl: string }) {
  return (
    <BrowserRouter basename={baseUrl}>
      <Switch>
        <Route exact path="/404">
          <NotFound />
        </Route>
        <Redirect to="/404" />
      </Switch>
    </BrowserRouter>
  );
}
